// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1PAMW","filesListContainer":"PosDisputesFiles_filesListContainer__eJv0E","filesButton":"PosDisputesFiles_filesButton__ETG-0"};